module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/cq05.56cd368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/blog/cq05.jpg
// module id = O2kK
// module chunks = 0